/* This file is autogenerated, see readme.md for instructions */
import CloneSvgIcon from '@bloomreach/banana-theme/icons/clone.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CloneIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CloneSvgIcon />
    </Icon>
  );
});

CloneIcon.displayName = 'CloneIcon';

export default CloneIcon;
